import styled from 'styled-components/macro'

import Typography from '@material-ui/core/Typography'

const Li = styled(Typography)`
  font-size: 1rem;
`

export default Li
